import type { RootState } from '../../types';
import { NAME as searchPrototype } from '../search.const';
import { NAME } from './search-requests.const';
import type { SearchRequestsState } from './search-requests.types';

const selectSearchRequestsState = (state: RootState): SearchRequestsState => state[searchPrototype][NAME];

export const selectRequestIds = (state: RootState): SearchRequestsState['requests'] =>
  selectSearchRequestsState(state).requests;
